import React, { FC } from 'react';
import Loader from 'components/Loaders/InsightsPayment';
import PaymentModal from 'components/Modals/PaymentModal';
import {
  Container,
  Title,
  Header,
  Caption,
  Row,
  // PickerContainer,
  // DatesSelector,
  // DateCaption,
} from './styles';
import useConnect from './connect';
import { Props } from './types';

const Payment: FC<Props> = ({ brandId }) => {
  const {
    payment,
    isLoading,
    setModalContent,
    modalContent,
    // hoverRange,
    // selectedDays,
    // handleDayChange,
    // handleDayEnter,
    // handleDayLeave,
    // handleWeekClick,
  } = useConnect({
    brandId,
  });
  return (
    <>
      {/* <PickerContainer>
        <DateCaption>Date range</DateCaption>
        <DatesSelector
          hoverRange={hoverRange}
          selectedDays={selectedDays}
          handleDayChange={handleDayChange}
          handleDayEnter={handleDayEnter}
          handleDayLeave={handleDayLeave}
          handleWeekClick={handleWeekClick}
        />
      </PickerContainer> */}
      <Title>Comments</Title>
      <Container>
        <Header>
          <Caption>SUBTOTAL</Caption>
          <Caption>TAX</Caption>
          <Caption>PLATFORM PAY</Caption>
          <Caption>NET PAY</Caption>
          <Caption align="left">BRAND</Caption>
          <Caption align="left">COMMENTS</Caption>
        </Header>
        {isLoading || !payment ? (
          <>
            <Loader opacity={1} />
            <Loader opacity={0.8} />
            <Loader opacity={0.6} />
            <Loader opacity={0.4} />
            <Loader opacity={0.2} />
            <Loader opacity={0} />
          </>
        ) : (
          payment.payments.map((item) => (
            <Row
              handleOpenModal={() => setModalContent(item)}
              key={item.subtotal + item.total + item.tax + item.comments}
              payment={item}
            />
          ))
        )}
      </Container>
      <PaymentModal
        modalContent={modalContent}
        handleClose={() => setModalContent(null)}
      />
    </>
  );
};

export default Payment;
